import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import ConversationEffect from "src/Animations/ConversationEffect";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_GEN_AI_DEMO_ISNA_1 = {
  title: "AI assistant available for\n context specific queries",
  subtitle: "Gen AI Demo",
  text: "ISNA Gen AI assistant can be accessed \nplatform-wide or triggered contextually\n (eg. calling it to diagnose an alarm).",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_207"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/ISNA/ISNA_GEN_AI_Demo_01.jpg",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_01_bubble_part_1.png",
          imageStyle: {
            position: "absolute",
            right: "114px",
            bottom: "211.58px",
          },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_01_screen.png",
          imageStyle: { position: "absolute", right: "169px", bottom: "315px" },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_01_bubble_part_2.png",
          imageStyle: {
            position: "absolute",
            right: "480.38px",
            bottom: "230.40px",
          },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_01_bubble_part_3.png",
          imageStyle: {
            position: "absolute",
            right: "477.23px",
            bottom: "234.22px",
          },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_01_bubble_part_4.png",
          imageStyle: { position: "absolute", right: "95px", bottom: "82px" },
        },
      ]}
      pageNumber={"ENG_206"}
      conversationStyle={{
        width: "auto",
        justifyContent: "center",
        alignItems: "center",
      }}
    />
  ),
};
